// Feature flags that were removed (always TRUE or always FALSE in production):
// - TERMINATION_FLOW_2022 (always TRUE)
// - END_EMPLOYMENT_WIZARD_2022 (always TRUE)
// - ENABLE_ESCALATIONS (always TRUE)
// - ENABLE_STAFF_MESSAGING (always TRUE)
// - ENABLE_CONTACT_US_ROUTING (always TRUE)
// - ENABLE_NECTAR (always TRUE)
// - TRAINING_CATALOG (always TRUE)
// - SHOW_ADD_STAFF_WIZARD (always TRUE)
// - ENABLE_CREATE_JOB_DESCRIPTIONS (always TRUE)
// - AI_JOB_DESCRIPTION (always TRUE, unused)
// - DISPLAY_HR_REQUESTS_IN_LEFT_NAV (always FALSE)
// - LOCK_LONG_STANDING_DELINQUENTS (always FALSE)
// - ENABLE_NECTAR_UPGRADE_NOTIFICATION (always FALSE)
// - EMPLOYEE_MANAGER_OPERATING_FEED (always FALSE)

const FeatureFlags = Object.freeze({
  ENABLE_BULK_STAFF_MESSAGING: 'bulk-staff-messaging',
  ENABLE_TRAINING: 'enable-training',
  AUTO_UPGRADE_TIER: 'auto-upgrade-tier',
  ENABLE_POLICY_REAFFIRMATIONS: 'enable-policy-reaffirmations',
  ENABLE_TEAM_PAGE: 'enable-team-page',
  MEETINGS_FEATURE: 'feature-meetings',
  H3_FLYWHEEL: 'h3-flywheel',
  PREMIUM_PEOPLE_MIGRATION: 'premium-people-migration',
  MIGRATION_BANNER: 'migration-banner',
});

export default FeatureFlags;
